import { render, staticRenderFns } from "./App.vue?vue&type=template&id=617ab0be&lang=pug&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('617ab0be')) {
      api.createRecord('617ab0be', component.options)
    } else {
      api.reload('617ab0be', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=617ab0be&lang=pug&", function () {
      api.rerender('617ab0be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/App.vue"
export default component.exports